<template>
    <div v-show="showLoader" class="loader"><img src="../assets/images/loader.gif" alt=""></div>
    <!--  Main Start Here  -->
    <main class="main_content">
        <!-- Page Title -->
        <div class="row mb-4 align-items-center">
            <div class="col-md-8">
                <h2 class="page_title">My Preferences</h2>
            </div>
        </div>
        <div class="card_box">
            <div class="table_listing">
                <table id="my_preferences" class="table display" style="width:100%">
                    <thead>
                        <tr>
                            <th>Action</th>
                            <th>Notification</th>
                            <th>Email</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(item, index) in preferences" :key="index">
                            <tr :data-id="item.main_pref_id">
                                <td>{{item.pref_name}}</td>
                                <td>
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" value="notification" type="checkbox" 
                                            :id="`notif_chk_${item.main_pref_id}`" :checked="(item.notification !== null && item.notification) == 1 ? true : false">
                                    </div>
                                </td>
                                <td>
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" value="email" type="checkbox" 
                                            :id="`notif_chk_${item.main_pref_id}`" :checked="(item.email !== null && item.email) == 1 ? true : false">
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="top_btns">
                        <br>
                            <button class="btn btn-primary" @click="updateMyPrefernces">
                                Save Preference
                            </button>
                        <br>
                    </div>
                </div>
            </div>
        </div>

    </main>
</template>
<script>
import $ from "jquery";
import "jszip";
import axios from 'axios';

export default {
    data() {
        return {
            showLoader: false,
            preferences: [],
            API_URL: process.env.VUE_APP_API_URL,
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        loggedIn() {
            return this.$store.state.auth.status.loggedIn;
        },
    },
    mounted() {
        this.getMyPreferences();
        if (!this.currentUser) {
            this.$router.push('/login');
        }
    },
    methods: {
        logOut() {
            this.$store.dispatch('auth/logout');
            this.$router.push('/login');
        },
        updateMyPrefernces() {
            this.showLoader = true;
            let pref_arr = [];
            $('#my_preferences > tbody > tr').each(function() {
                let pref_obj = {};
                let row = $(this);
                pref_obj.id = row.data('id');
                row.find("input").each(function() {
                    if ($(this).is(':checked')) {
                        pref_obj[$(this).val()] = 1;
                    } else {
                        pref_obj[$(this).val()] = 0;
                    }
                });
                pref_arr.push(pref_obj);
            });
            if (pref_arr.length > 0) {
                const headersData = {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': "Bearer " + this.currentUser.accessToken
                    }
                };
                let action;
                if (this.currentUser.user_type == 4) {
                    action = this.API_URL + 'customer/update-my-preferences';
                }
                if (this.currentUser.user_type == 3) {
                    action = this.API_URL + 'supplier/update-my-preferences';
                }
                axios.post(action, { pref_arr : JSON.stringify(pref_arr) }, headersData)
                    .then((result) => {
                        if (result.status) {
                            this.showLoader = false;
                            this.$toast.show(result.data.message, {
                                type: "success",
                                dismissible: true,
                                position: 'top',
                                duration: 3500,
                                pauseOnHover: true,
                            });
                        } else {
                            this.showLoader = false;
                            this.$toast.show(result.data.message, {
                                type: "error",
                                dismissible: true,
                                position: 'top',
                                duration: 3500,
                                pauseOnHover: true,
                            });
                        }
                    })
                    .catch((error) => {
                        console.error("There was an error!", error);
                        this.showLoader = false;
                    });
            }

        },
        getMyPreferences() {
            const headersData = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': "Bearer " + this.currentUser.accessToken
                }
            };
            let action;
            if (this.currentUser.user_type == 4) {
                action = this.API_URL + 'customer/get-my-preferences';
            }
            if (this.currentUser.user_type == 3) {
                action = this.API_URL + 'supplier/get-my-preferences';
            }
            axios.post(action, {}, headersData)
                .then((result) => {
                    if (result.status) {
                        this.preferences = result.data.data.preferences;
                    } else {
                        this.$toast.show(result.data.message, {
                            type: "error",
                            dismissible: true,
                            position: 'top',
                            duration: 3500,
                            pauseOnHover: true,
                        });
                    }
                })
                .catch((error) => {
                    console.error("There was an error!", error);
                });
        },
    },
};
</script>